<template>
	<div class="bbs_tit_g">
		<div class="tit_info">
			<strong class="tit_item">{{ title }}</strong>
			<p class="desc_item">{{ description }}</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {type: String, required: true},
		description: {type: String, required: true},
	}
}
</script>
